import React from 'react';

import { faUserTag } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

import AutocompleteSearch from '../components/AutocompleteSearch';
import ResourceList from '../components/ResourceList';
import StrongTextField from '../components/StrongTextField';
import jointure_clients from './jointure_clients';

export default {
  name: 'entites',
  title: 'Entités clientes',
  icon: faUserTag,
  resource: 'entite_cliente',
  query: {
    _associations: 'client',
    _fields: 'identite,type,nom,adresse,cp,ville',
  },
  primaryKey: 'identite',
  head: {
    type: 'Type',
    nom: 'Nom',
    prenom: 'Prénom',
    adresse: 'Adresse',
    cp: 'Code postal',
    ville: 'Ville',
  },
  list: ({ values }) => [values.type, values.nom, values.client?.prenom, values.adresse, values.cp, values.ville],
  filter: ({ values, props, setFieldValue, handleSubmit }) => [
    <StrongTextField name='nom' label='Nom' value={values.nom} {...props} />,
    <StrongTextField name='prenom' label='Prenom' value={values.prenom} {...props} />,
    <StrongTextField name='ville' label='Ville' value={values.ville} {...props} />,
    <AutocompleteSearch
      {...props}
      resource='individu'
      optionLabel={option => option.nom + ' ' + option.prenom}
      attribute='nom'
      filters={{ conseiller: 1 }}
      label='Conseiller'
      onChange={(event, value) => {
        setFieldValue('idindividu', value?.idindividu);
        handleSubmit();
      }}
    />,
  ],
  edit: ({ values, props }) => [
    <TextField fullWidth name='nom' label='Nom' value={values.nom} {...props} />,
    <TextField fullWidth name='type' label='Type' value={values.type} {...props} />,
    <TextField fullWidth name='adresse' label='adresse' value={values.adresse} {...props} />,
    <TextField fullWidth name='cp' label='Code postal' value={values.cp} {...props} />,
    <h2>Personnes</h2>,
    <ResourceList {...jointure_clients} options={{ identite: values.identite }} conseiller={values.idindividu} />,
  ],
  add: true,
  popup: true,
  remove: true,
};
